"use strict";

import format from 'string-template';

const SN_TRANSLATE = 'sn-translate';
const TRANSLATIONS = '__TRANSLATIONS__';
const TRANSLATIONS_PREFIX = '__TECTONIC_TRANSLATIONS_PREFIX__';
const TRANSLATIONS_STORE = '__TECTONIC_TRANSLATIONS__';
const STATIC_TRANSLATIONS = window && window[TRANSLATIONS] || (window[TRANSLATIONS] = {});
const DEFAULT_TRANSLATIONS = Object.assign({}, STATIC_TRANSLATIONS);

if (!window[TRANSLATIONS_STORE])
	window[TRANSLATIONS_STORE] = DEFAULT_TRANSLATIONS;

function attachToWindow ({ compat = false } = {}) {
	const translationProperties = Reflect.getOwnPropertyDescriptor(window, TRANSLATIONS);
	if (translationProperties.configurable) {
		Object.defineProperty(window, TRANSLATIONS, {
			configurable: compat,
			get() {
				return Object.assign({}, window[TRANSLATIONS_STORE]);
			},
			set(value) {
				if (!window[TRANSLATIONS_STORE])
					window[TRANSLATIONS_STORE] = Object.assign({}, STATIC_TRANSLATIONS);

				appendTranslations(value);
			}
		})
	} else {
		console.warn(`[${SN_TRANSLATE}] If you're seeing this message, it probably means that you've loaded two copies of ${SN_TRANSLATE} on the page. At this time, only a single copy of ${SN_TRANSLATE} can be loaded at a time.`);
	}
}

function getPrefix() {
	if (!window)
		return '';

	if (window[TRANSLATIONS_PREFIX])
		return window[TRANSLATIONS_PREFIX];

	const enabled = window.__TRANSLATIONS_PREFIX_ENABLED__;
	const prefixName = window.__TRANSLATIONS_PREFIX__ || 'SNT';
	window.__TRANSLATIONS_PREFIX_ENABLED__ = void 0;
	window.__TRANSLATIONS_PREFIX__ = void 0;
	window[TRANSLATIONS_PREFIX] = enabled ? `${prefixName}:` : '';

	return window[TRANSLATIONS_PREFIX];
}

export function appendTranslations(translations) {
	for (const k in translations)
		window[TRANSLATIONS_STORE][k] = translations[k];
}


/**
 * the first parameter of t can be a string or an object of the format:
 * {code: 'code', message: 'Hello!', comment: 'used by translators, ignored by t'}
 * t can transform ordered parameters or named parameters: 'User Status: {0} or 'User Status: {firstName}'
 * @param {*} val 
 * @param  {...any} rest 
 */
export function t(val, ...rest) {
	if (!window[TRANSLATIONS_STORE])
		window[TRANSLATIONS_STORE] = DEFAULT_TRANSLATIONS;
 
	const translations = window[TRANSLATIONS_STORE];
	const prefix = getPrefix();    

	let key = val;
	let codeKey;

	//check for possible new format of translations
	if(val && typeof val === 'object' && val.message) {
		key = val.message;
		if(val.code)
			codeKey = `${val.code}:${val.message}`;
	}

	const translation = translations[codeKey] || translations[key] || key; 	//requirements order of precedence
	return format(`${prefix}${translation}`, ...rest);
}

export function hasTranslation(str) {
	return window[TRANSLATIONS_STORE].hasOwnProperty(str)
}

if (process && process.env && parseInt(process.env.SN_TRANSLATE_COMPAT)) 
	attachToWindow({ compat: true });
else
	attachToWindow();
